<template>
    <span v-if="status" :class="asTag ? ['tag', `is-${status.color}`] : `has-text-${status.color}`">
        {{ translate(status.translationKey) }}
    </span>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import {
        AUTO_DQ,
        CANDIDATE,
        CANNOT_UNDO_DUE_TO_FINISHED_FIGHT,
        DISQUALIFIED_FAILED_VERIFICATION,
        DISQUALIFIED_NO_PAYMENT,
        MISSED_FIGHT,
        VerificationState,
        VERIFIED,
    } from "../Api/verifications";

    const props = defineProps<{
        verificationState: VerificationState;
        asTag?: boolean;
    }>();

    const statuses = new Map<VerificationState, { color: string; translationKey: string }>([
        [CANDIDATE, { color: "info", translationKey: "admin_verification.single_candidate" }],
        [VERIFIED, { color: "success", translationKey: "admin_verification.single_verified" }],
        [DISQUALIFIED_NO_PAYMENT, { color: "danger", translationKey: "admin_verification.single_no_payment" }],
        [DISQUALIFIED_FAILED_VERIFICATION, { color: "warning", translationKey: "admin_verification.single_disqualified" }],
        [MISSED_FIGHT, { color: "danger", translationKey: "admin_verification.missed_fight" }],
        [CANNOT_UNDO_DUE_TO_FINISHED_FIGHT, { color: "danger", translationKey: "admin_verification.cannot_undo_due_to_finished_fight" }],
        [AUTO_DQ, { color: "warning", translationKey: "common.auto_dq" }],
    ]);

    const status = computed(() => statuses.get(props.verificationState));
</script>

<style scoped></style>
